<div class="login">
  <form class="login__form" [formGroup]="loginForm" (ngSubmit)="login_user()">
    <h2 class="login__cap">Login to Your SignNow Account</h2>

    <div class="login__form-group">
      <input
        type="email"
        placeholder="Email"
        class="sn-sf-input"
        formControlName="email"
        [ngClass]="{ invalid: isValueInvalid(loginForm.get('email')) }"
      />
      <span class="helped-text red-text" *ngIf="isValueInvalid(loginForm.get('email'))">
        Please enter a valid email address
      </span>
    </div>

    <div class="login__form-group">
      <input
        type="password"
        placeholder="Password"
        class="sn-sf-input"
        formControlName="pass"
        [ngClass]="{ invalid: isValueInvalid(loginForm.get('pass')) }"
      />
      <span class="helped-text red-text" *ngIf="isValueInvalid(loginForm.get('pass'))">
        Please enter a password
      </span>
    </div>

    <div class="login__form-footer">
      <button class="btn btn-sm btn-primary" type="submit" [disabled]="loginForm.invalid">Login</button>
      <!--      TODO Style 'Create account' button like on other 'Login' pages -->
      <!--      <a-->
      <!--        class="btn btn-primary create-account"-->
      <!--        href="https://snseats.signnow.com/purchase/business_free_trial/loggedout?source=salesforce"-->
      <!--        target="_blank"-->
      <!--      >-->
      <!--        Create account-->
      <!--      </a>-->
    </div>
  </form>
</div>
